import React from "react";
import { motion } from "framer-motion";
import { Layers, Boxes, Radar } from "lucide-react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

const ICONS = [Layers, Boxes, Radar];

export default function Projects() {
  const { portfolio, partner } = COURSE;
  return (
    <section id="projects" data-testid="projects-section" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/4 h-[400px] w-[400px] glow-blue opacity-50" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Reveal>
              <Eyebrow>Projects &amp; Portfolio</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
                You graduate with proof, not just a certificate.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-base leading-relaxed text-[#566076]">
              Build in-hand experience from every module and every tool — then prove it with two complete, real-world projects.
            </p>
          </Reveal>
        </div>

        <StaggerGroup className="mt-14 grid gap-5 md:grid-cols-3">
          {portfolio.points.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <StaggerItem
                key={p.title}
                className="card-glow group relative h-full overflow-hidden rounded-3xl border border-[#293891]/10 bg-white p-8 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#293891]/10 bg-[#F5F7FC] text-[#3B82F6]">
                    <Icon size={22} />
                  </div>
                  <span className="font-display text-4xl font-semibold text-[#293891]/[0.08]">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-display text-xl font-medium text-[#293891]">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#566076]">{p.desc}</p>
              </StaggerItem>
            );
          })}
        </StaggerGroup>

        {/* Technology partner ribbon */}
        <Reveal delay={0.15}>
          <motion.div
            whileHover={{ y: -3 }}
            className="mt-6 flex flex-col items-start justify-between gap-5 overflow-hidden rounded-3xl border border-[#293891]/10 bg-[#293891] p-8 md:flex-row md:items-center md:p-10"
            data-testid="partner-ribbon"
          >
            <div className="flex items-center gap-5">
              <span className="text-xs uppercase tracking-[0.24em] text-[#8ea0c4]">{partner.role}</span>
              <span className="hidden h-8 w-px bg-white/15 sm:block" />
              <span className="inline-flex items-center rounded-xl bg-white px-4 py-3 shadow-sm">
                <img src={partner.logo} alt={partner.name} className="h-8 w-auto md:h-9" />
              </span>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-[#c3cee3] md:text-right">{partner.desc}</p>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
